var r = /* @__PURE__ */ ((m) => (m.Medium = "md", m.Small = "sm", m))(r || {});
export {
  r as SlideSize
};
